import { createSignal, onMount } from "solid-js";
import { useApplication } from "@/context/app";
import {
  Card,
  CardContent,
} from "@/components/shadcn/card";
import { activateAction, deactivateAction, deleteAction } from "../../components/ui/actions/config";
import { ListControl } from "../../components/ui/list/ListControl";
import { TableView } from "../../components/ui/list/TableView";
import { getSessionColumns } from "./columns";
import { CreateButton } from "../../components/ui/Button";
import { useNavigate, useParams } from "@solidjs/router";

export default function SessionList() {

  const navigate = useNavigate();

  const { setBreadcrumb } = useApplication();
  const [therapy, setTherapy] = createSignal(null);

  const actions = [
    activateAction('session', 'session'),
    deactivateAction('session', 'session'),
    deleteAction('session', 'session')
  ];

  const statuses = [{
    text: 'Active',
    value: true
  }, {
    text: 'Inactive',
    value: false
  }];

  const sorts = [{
    "text": 'Created At',
    "value": "created_at"
  }, {
    "text": 'Name',
    "value": "name"
  }];

  const params = useParams();
  if (params.therapy !== undefined && params.therapy !== null) {
    setTherapy(params.therapy);
  } else {
    navigate("/therapies");
  }

  onMount(async () => {
    setBreadcrumb([
      {
        name: 'Home',
        link: '/home'
      },
      {
        name: 'Therapy',
        link: '/therapies'
      },
      {
        name: 'Sessions',
        current: true
      }
    ]);
  });

  return (
    <>
      <div class="flex">
        <CreateButton href={"/therapy/" + therapy() + "/session/create"}>New Session</CreateButton>
      </div>
      <Card class="w-full">
        <CardContent>
          <ListControl
            search={''}
            mode="table"
            actions={actions}
            filters={[
              {
                type: 'date',
                label: 'Created At',
                name: 'created_at',
                default: null
              }
            ]}
            sort={{
              column: 'created_at',
              direction: 'asc'
            }}
            pagination={{
              current: 1, // default 1
              changePerPage: true, // default true
              perPage: 10, // default 10
              options: [10, 20, 50, 100]
            }}
            datasource={{
              type: 'remote',
              config: {
                url: '/therapy-session/fetch',
                method: 'GET',
                params: {
                  therapy: therapy()
                }
              }
            }}
          >{(innerProps) => <TableView actionKey='key' {...innerProps} columns={getSessionColumns({ onListAction: innerProps.onAction, therapy: therapy() })} />}
          </ListControl>
        </CardContent>
      </Card>
    </>
  );
}
